import React from "react";
import Pagination from "./Pagination";

interface Props {
  search: string;
  onSearchChange: (val: string) => void;
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const SearchHeader: React.FC<Props> = ({
  search,
  onSearchChange,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
     
      <input
        type="text"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Search for companies"
        className="border rounded px-4 py-2 w-1/2"
      />

    
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default SearchHeader;
